import { getPaymentDetails } from "@Pages/Payment/utils";
import isAvailable from "../components/AccommodationDetails/helper";
import { AppThunk } from "@Store/index";
import { updatePaymentdata, updatePriceSummary } from "./bookFormReducer";
import getPaymentSummary from "@Utils/getPaymentSummary";

const dispatchPaymentData =
  (formData: any): AppThunk =>
  async (dispatch, getState: any) => {
    const { bookFormData } = getState();
    const { data: inventoryData, leadData, paymentInfo } = bookFormData;
    const availableRooms = inventoryData?.active_children?.filter((config: any) =>
      isAvailable(config),
    );
    // if fixed duration and flexible move in -> currentTenancyId else -> inventory_id
    const tenancyID =
      formData?.accommodationDetails?.tenancyId || formData?.accommodationDetails?.inventory_id;
    const {
      accommodationDetails,
      personalDetails,
      inventoryCardSummary,
      emergencyDetails,
      roommateDetails,
      guarantorDetails,
    } = formData || {};
    const configType = availableRooms?.find(
      (room: any) => room.id === accommodationDetails?.roomType,
    );

    // organize booking details
    const newBookingDetails: any = {
      user_details: {
        name: personalDetails?.["user_details/name"],
        email: personalDetails?.["user_details/email"],
        phone: personalDetails?.["user_details/phone"],
        phone_code: `+${personalDetails?.["user_details/phone_code"]?.split("+")[1]}`,
        country_code: personalDetails?.["user_details/phone_code"],
      },
      inventory_id: tenancyID,
      roomType: configType,
      tenancy: accommodationDetails?.duration,
      tenancyObj: tenancyID
        ? inventoryData?.active_children?.find((ten: any) => ten.id === tenancyID)
        : null,
      moveInDate: inventoryCardSummary?.moveInDate,
      moveOutDate: inventoryCardSummary?.moveOutDate,
    };
    if (accommodationDetails?.arrival_date)
      newBookingDetails.arrival_date = accommodationDetails?.arrival_date;
    if (accommodationDetails?.custom_duration)
      newBookingDetails.custom_duration = accommodationDetails?.custom_duration;

    // get payment details
    let paymentData: any = getPaymentDetails(
      getState()?.bookFormData?.data,
      newBookingDetails?.tenancyObj || newBookingDetails?.roomType,
    );
    if (leadData) paymentData.lead_id = leadData.id;

    // delete phone code with country name in api payload
    if (newBookingDetails?.user_details?.country_code)
      delete newBookingDetails.user_details.country_code;

    paymentData = {
      ...paymentData,
      inventory_id: newBookingDetails.inventory_id,
      user_details: newBookingDetails.user_details,
      name: newBookingDetails.user_details.name,
      description: `Payment for ${newBookingDetails.roomType?.name}`,
      additional_details: {
        ...accommodationDetails,
        ...roommateDetails,
        ...personalDetails,
        ...emergencyDetails,
        ...guarantorDetails,
      },
    };

    const additionUserDetails = paymentData?.additional_details;

    if (
      additionUserDetails &&
      Object.keys(additionUserDetails).length > 0 &&
      additionUserDetails["user_details/phone"]
    ) {
      const code =
        additionUserDetails["user_details/phone_code"]?.split("+").length > 1
          ? additionUserDetails["user_details/phone_code"]?.split("+")[1]
          : additionUserDetails["user_details/phone_code"];

      paymentData.additional_details[
        "user_details/phone"
      ] = `${code}${additionUserDetails["user_details/phone"]}`;
    }

    if (paymentData?.user_details?.phone) {
      const code =
        paymentData?.user_details?.phone_code?.split("+").length > 1
          ? paymentData?.user_details?.phone_code?.split("+")[1]
          : paymentData?.user_details?.phone_code;

      paymentData.user_details.phone = `${code}${paymentData?.user_details?.phone}`;
    }

    dispatch(updatePaymentdata(paymentData || {}));
    dispatch(
      updatePriceSummary({
        ...getPaymentSummary(paymentInfo?.payment_info),
        payment_info: paymentInfo?.payment_info,
      }),
    );
  };

export default dispatchPaymentData;
